module.exports = __webpack_public_path__ + "img/mov.3a90be6.svg";